/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum SsoClientApps {
  CHROME_EXTENSION="CHROME_EXTENSION",
DRIVER_MOBILE_APP="DRIVER_MOBILE_APP",
DISPATCHER_APP="DISPATCHER_APP"
}

/**
* SsoClientApps
*/
export const SsoClientAppsEnumType = types.enumeration("SsoClientApps", [
        "CHROME_EXTENSION",
  "DRIVER_MOBILE_APP",
  "DISPATCHER_APP",
      ])
